import script from "./PositionItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./PositionItem.vue?vue&type=script&lang=ts&setup=true"

import "./PositionItem.vue?vue&type=style&index=0&id=5e9d7fcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e9d7fcc"]])

export default __exports__